import React from "react";
import { Layout } from "antd";

function FooterDashboard() {
  const { Footer } = Layout;

  return (
    <>
    <div className="py-4 my-4">
    </div>
      <Footer className="footerClass" style={{ textAlign: "center" }}>
        {/* Add your footer content here */}
        © FoodFlow Food Logistic Management System Developed by <a href="https://www.haassolutions.co.uk" target="_blank"><b>HAAS Solutions</b></a> 
      </Footer>
    </>
  );
}

export default FooterDashboard;
